import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import * as Selectors from '../store/selectors';
import { connect } from 'react-redux';
class PrintVariables extends React.Component {
    render() {
        var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        var datum = new Date();
        var heute = ' ' + datum.getUTCDate() + '/' + months[datum.getUTCMonth()] + '/' + datum.getUTCFullYear();

        function VersorgungSwitch(param) {
            switch (param) {
                case 'geberit_mapress':
                    return 'Geberit Mapress';
                case 'geberit_mepla':
                    return 'Geberit Mepla';
                case 'geberit_volex':
                    return 'Geberit Volex';
                default:
                    return;
            }
        }
        function EntwaesserungSwitch(param) {
            switch (param) {
                case 'geberit_silent_pro':
                    return 'Geberit Silent-Pro';
                case 'geberit_silent_db20':
                    return 'Geberit Silent-db20';
                case 'geberit_silent_pp':
                    return 'Geberit Silent-PP';
                default:
                    return;
            }
        }
        function SteinsortenSwitch(param) {
            switch (param) {
                case 'basiswand_geberit':
                    return 'STEINSORTE_BASISWAND_GEBERIT';
                case 'bims_vollsteine':
                    return 'STEINSORTE_BIMS_VOLLSTEINE';
                case 'geberit_volex':
                    return 'STEINSORTE_BIMS_HOHLBLOCKSTEINE';
                    case 'geberit_volex':
                        return 'STEINSORTE_BIMS_HOHLBLOCKSTEINE';
                        case 'geberit_volex':
                            return 'STEINSORTE_BIMS_HOHLBLOCKSTEINE';
                            case 'geberit_volex':
                                return 'STEINSORTE_BIMS_HOHLBLOCKSTEINE';
                                case 'geberit_volex':
                                    return 'STEINSORTE_BIMS_HOHLBLOCKSTEINE';
                default:
                    return;
            }
        }

        return (
            <div>
                <img className="GeberitPrintLogo" src={`./assets/img/geberit-logo.jpg`} />

                <div>
                    <div className="PrintDatum">
                        <FormattedHTMLMessage id="DruckDatum" />
                        {heute}
                    </div>
                    <div className="PrintLine1">
                        <FormattedHTMLMessage id="DruckHeadline1" />
                    </div>
                    <div className="PrintLine2">
                        <FormattedHTMLMessage id="DruckHeadline2" />
                    </div>
                    <div className="PrintLine3">
                        <FormattedHTMLMessage id="DruckHeadline3" />
                    </div>
                    <div className="PrintLine4">
                        <FormattedHTMLMessage id="DruckHeadline4" />
                    </div>
                    <div className="PrintLine5">
                        <FormattedHTMLMessage id="DruckSubline1" />
                    </div>
                    <div className="PrintLine6">
                        <FormattedHTMLMessage id="DruckSubline2" />
                    </div>
                </div>

                <img className="PrintLogo2" src={`./assets/img/knowhowinstalled.jpg`} />
                <img className="GeberitPrintSeite55" src={`./assets/img/seite55_` + document.getElementById('root').dataset.locale + `.jpg`} />

                <u>
                    {' '}
                    <FormattedHTMLMessage id="DruckUeberschriftGrafik" />
                </u>
                <br />
                <br />

                <div className="UeberschtriftPrintingView">{this.props.allProps.result.imageTitle}</div>
                <div className="printPutz">
                    <FormattedHTMLMessage id="DruckPutz" />
                </div>
                <div className="printWandbeschreibung">
                    <FormattedHTMLMessage id="DruckWandbeschreibung" />
                </div>     
                <div className="printFlaechengewicht">
                    <FormattedHTMLMessage id="DruckFlaechengewicht" />
                </div>   
                
                {this.props.steinsorte != null &&    
                    <div className="steinsorteText">
                        <FormattedHTMLMessage id="steinsorte-label" />
                    </div>
                }
                {this.props.steinsorte != null &&   
                    <div className="steinsorteVariable">                     
                        <FormattedHTMLMessage id={this.props.steinsorte}/>                     
                    </div>
                }


                <div className="Versorgungssysteme">
                    <FormattedHTMLMessage id="Versorgungssysteme" />
                </div>
                <div className="Steigstrang">
                    <FormattedHTMLMessage id="Steigstrang" />
                </div>
                <div className="SteigstrangAktuell">
                    {VersorgungSwitch(this.props.steigstrang)}
                    <FormattedHTMLMessage id="Brandschutz" />
                </div>
                <div className="AnschlussleitungenVersorgung">
                    {VersorgungSwitch(this.props.anschlussLeitung)}
                    <FormattedHTMLMessage id="Brandschutz" />
                </div>
                <div className="Entwaesserungssysteme">
                    <FormattedHTMLMessage id="Entwaesserungssysteme" />
                </div>
                <div className="Fallleitung">
                    <FormattedHTMLMessage id="Fallleitung" />
                </div>
                <div className="FallleitungAktuell">
                    {EntwaesserungSwitch(this.props.abwasserFa)}
                    <FormattedHTMLMessage id="Brandschutz" />
                </div>
                <div className="AnschlussleitungenEntwaesserung">
                    {EntwaesserungSwitch(this.props.abwasserAn)}
                    <FormattedHTMLMessage id="Brandschutz" />
                </div>
                <div className="Anschlussleitungen">
                    <FormattedHTMLMessage id="Anschlussleitungen" />
                </div>

                <img className="PrintWallImage" src={`./assets/img/reports/printview/${this.props.allProps.result.filenameWithoutExtension}.jpg`} />
                <object
                    id="PrintWallImageSVG"
                    className="PrintWallImageSVG"
                    data={`./assets/img/reports/svg/${this.props.allProps.result.filenameWithoutExtension}.svg`}
                />

                <div className="newspot">newspot</div>
                <div className="PrintTableHeading">{this.props.result.installationsGeraeuscheTableHeading}</div>
                <div className="printWanddicke">
                    <FormattedHTMLMessage id="wandstaerke-label" />
                </div>    
                <div className="printMessort">
                    <FormattedHTMLMessage id="DruckMessort" />
                </div>
                <div className="printKeineAnforderung">
                    <FormattedHTMLMessage id="DruckKeineAnforderung" />
                </div>
                <div className="printOhneBetaetigung">
                    <FormattedHTMLMessage id="DruckOhneBetaetigung" />
                </div>
                <div className="printMitBetaetigung">
                    <FormattedHTMLMessage id="DruckMitBetaetigung" />
                </div>
                <div className="printErgebnis">
                    <FormattedHTMLMessage id="DruckErgebnis" />
                </div>
                <div className="printAnforderung">
                    <FormattedHTMLMessage id="DruckAnforderung" />
                </div>
                <div className="printDiagonalDarunter">
                    <FormattedHTMLMessage id="DruckDiagonalDarunter" />
                </div>
                <div className="printFremdenBereich">
                    <FormattedHTMLMessage id="DruckFremdenBereich" />
                </div>
                <div className="printAngrenzenderRaum">
                    <FormattedHTMLMessage id="DruckAngrenzenderRaum" />
                </div>
                <div className="printBereichEigen">
                    <FormattedHTMLMessage id="DruckBereichEigen" />
                </div>

                <div className="FussNote1">
                    <FormattedHTMLMessage id="DruckFussnote1" />
                </div>
                <div className="FussNote2">
                    <FormattedHTMLMessage id="DruckFussnote2" />
                </div>
                <div className="LinkLine1">
                    <FormattedHTMLMessage id="DruckLinkLine1" />
                </div>
                <div className="LinkLine2">
                    <FormattedHTMLMessage id="DruckLinkLine2" />
                </div>
                <div className="AnschriftFirma">
                    <FormattedHTMLMessage id="DruckAnschriftFirma" />
                </div>
                <div className="AnschriftStrasse">
                    <FormattedHTMLMessage id="DruckAnschriftStrasse" />
                </div>
                <div className="AnschriftStadt">
                    <FormattedHTMLMessage id="DruckAnschriftStadt" />
                </div>
                <div className="AnschriftLand">
                    <FormattedHTMLMessage id="DruckAnschriftLand" />
                </div>
                <div className="AnschriftEmail">
                    <FormattedHTMLMessage id="DruckAnschriftEmail" />
                </div>
                <div className="AnschriftTelefon">
                    <FormattedHTMLMessage id="DruckAnschriftTelefon" />
                </div>
                <div className="AnschriftTelefonUeberschrift">
                    <FormattedHTMLMessage id="DruckAnschriftTelefonUeberschrift" />
                </div>
                <div className="AnschriftFax">
                    <FormattedHTMLMessage id="DruckAnschriftFax" />
                </div>
                <div className="AnschriftUrl">
                    <FormattedHTMLMessage id="DruckAnschriftUrl" />
                </div>

                <div className="PutzCheck">{this.props.putz == true ? <>true</> : <>false</>}</div>


                <div className="printFussnoteSilentPro">
                    <FormattedHTMLMessage id="DruckSilentPro" />
                </div>    

                <div className="SubheadlineTabelle">
                    <FormattedHTMLMessage id="ergebniss-subheadline-korrektur" />
                </div>
                <div className="PrintBerechnet">
                    <FormattedHTMLMessage id="DruckBerechnet" />
                </div>
                <div className="PrintFussnoteKorrektur">
                    <FormattedHTMLMessage id="DruckKorrekturHinweis" />
                </div>

                <div className="DIN41091Check">
                    {this.props.allProps.result.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten <= 30 ? (
                        <FormattedHTMLMessage id="DruckErfüllt" />
                    ) : (
                        <FormattedHTMLMessage id="DruckNichtErfüllt" />
                    )}
                </div>
                <div className="DIN4109Beiblatt">
                    {this.props.allProps.result.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten <= 25 ? (
                        <FormattedHTMLMessage id="DruckErfüllt" />
                    ) : (
                        <FormattedHTMLMessage id="DruckNichtErfüllt" />
                    )}
                </div>
                <div className="VDISST1Zeile1Check">
                    {this.props.allProps.result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 30 ? (
                        <FormattedHTMLMessage id="DruckErfüllt" />
                    ) : (
                        <FormattedHTMLMessage id="DruckNichtErfüllt" />
                    )}
                </div>
                <div className="VDISST2Zeile1Check">
                    {this.props.allProps.result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 27 &&
                    this.props.allProps.result.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMitKorrekturWerten <= 37 ? (
                        <FormattedHTMLMessage id="DruckErfüllt" />
                    ) : (
                        <FormattedHTMLMessage id="DruckNichtErfüllt" />
                    )}
                </div>
                <div className="VDISST3Zeile1Check">
                    {this.props.allProps.result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= 24 &&
                    this.props.allProps.result.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMitKorrekturWerten <= 34 ? (
                        <FormattedHTMLMessage id="DruckErfüllt" />
                    ) : (
                        <FormattedHTMLMessage id="DruckNichtErfüllt" />
                    )}
                </div>
                <div className="VDISST1Zeile2Check">
                    {this.props.allProps.result.LAF_VDI_ohneGeraeuscheImAngrenzendenRaumMitKorrekturWerten <= 35 &&
                    this.props.allProps.result.LAF_VDI_mitGeraeuschenImAngrenzendenRaumMitKorrekturWerten <= 45 ? (
                        <FormattedHTMLMessage id="DruckErfüllt" />
                    ) : (
                        <FormattedHTMLMessage id="DruckNichtErfüllt" />
                    )}
                </div>
                <div className="VDISST2Zeile2Check">
                    {this.props.allProps.result.LAF_VDI_ohneGeraeuscheImAngrenzendenRaumMitKorrekturWerten <= 30 &&
                    this.props.allProps.result.LAF_VDI_mitGeraeuschenImAngrenzendenRaumMitKorrekturWerten <= 40 ? (
                        <FormattedHTMLMessage id="DruckErfüllt" />
                    ) : (
                        <FormattedHTMLMessage id="DruckNichtErfüllt" />
                    )}
                </div>

                <div className="ResultDiagonalDarunter">{this.props.allProps.result.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten} dB(A)</div>
                <div className="ResultDiagonalDarunterOhne">
                    {this.props.allProps.result.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten} dB(A)
                </div>
                <div className="ResultDiagonalDarunterMit">
                    {this.props.allProps.result.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMitKorrekturWerten} dB(A)
                </div>
                <div className="ResultAngrenzend">{this.props.allProps.result.LAF_DIN_angrenzenderRaumMitKorrekturWerten} dB(A)</div>
                <div className="ResultAngrenzendOhne">{this.props.allProps.result.LAF_VDI_ohneGeraeuscheImAngrenzendenRaumMitKorrekturWerten} dB(A)</div>
                <div className="ResultAngrenzendMit">{this.props.allProps.result.LAF_VDI_mitGeraeuschenImAngrenzendenRaumMitKorrekturWerten} dB(A)</div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    result: Selectors.getResultValues(state),
    translationsAvalible: Selectors.isTranslationAvalible(state),
    korrekturWerte: Selectors.getKorrekturWerte(state),
    abwasserFallleitung: Selectors.getAbwasserFallleitungChoices(state),
    abwasserAnschlussleitung: Selectors.getAbwasserAnschlussleitungChoices(state),
    abwasserFallleitungActive: state.choices.abwasserFallleitung,
    abwasserAnschlussleitungActive: state.choices.abwasserAnschlussleitung,
    steigstrang: state.choices.trinkwasserSteigstrang,
    anschlussLeitung: state.choices.trinkwasserAnschlussleitung,
    putz: state.choices.putz,
    wandstaerke: state.choices.wandstaerke,
    steinsorte: state.choices.steinsorte,
    installationssystem: state.choices.installationssystem,
    wandbau: state.choices.wandaufbau,
});

export default connect(mapStateToProps)(PrintVariables);
